import { Link } from "react-router-dom";

export default function Breadcrumbs({ trail }) {
  // trail: [[label, href|null], ...] — last item is the current page
  return (
    <nav aria-label="Breadcrumb" className="text-[12px] uppercase tracking-[0.16em] text-smoke" data-testid="breadcrumbs">
      {trail.map(([label, href], i) => (
        <span key={i}>
          {href ? (
            <Link to={href} className="transition-colors hover:text-olive">
              {label}
            </Link>
          ) : (
            <span className="text-ink/70" aria-current="page">
              {label}
            </span>
          )}
          {i < trail.length - 1 && <span className="mx-2.5 text-ink/30">/</span>}
        </span>
      ))}
    </nav>
  );
}
